import React from 'react'

function VideoBackground(props){
  return (
  <div className="mi-home-video">
    <video id="background-video" muted loop autoPlay>
    <source src={props.videoURL} type="video/mp4" />
    Your browser does not support the video tag.
    </video>
    <img src={props.imageURL} alt="title" />
  </div>
  )
}

export default VideoBackground;
